(() => {
  const CART_OPEN_SELECTOR = '[data-rc-cart-open]';
  const CART_COUNT_SELECTOR = '[data-rc-cart-count]';
  const CART_LINES_UPDATE = 'shopify:cart:lines-update';
  const CART_ADD_PATTERN = /\/cart\/add(\.js)?/;

  const getItemCount = (cart) => {
    if (!cart?.items?.length) return 0;
    return cart.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll(CART_COUNT_SELECTOR).forEach((node) => {
      node.textContent = String(count);
    });
  };

  const syncCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      updateCartCount(getItemCount(cart));
    } catch (_) {
      /* ignore */
    }
  };

  const whenUpcartReady = (callback, attempts = 80) => {
    if (typeof window.upcartOpenCart === 'function') {
      callback();
      return;
    }

    if (attempts <= 0) return;
    window.setTimeout(() => whenUpcartReady(callback, attempts - 1), 150);
  };

  const closeUpcartQuietly = () => {
    if (typeof window.upcartCloseCart === 'function') {
      window.upcartCloseCart();
    }
  };

  const installOpenPatch = () => {
    if (typeof window.upcartOpenCart !== 'function') return;
    if (window.upcartOpenCart.__rcPatched) return;

    const originalOpen = window.upcartOpenCart.bind(window);
    const patched = (...args) => {
      if (window.RCLAB?.cartOpenBlocked) {
        closeUpcartQuietly();
        return;
      }
      return originalOpen(...args);
    };
    patched.__rcPatched = true;
    window.upcartOpenCart = patched;
  };

  const interceptChargerOffer = (cart) => {
    const offer = document.querySelector('rc-charger-offer');
    if (!offer) return false;
    if (offer.getAttribute('data-bypass') === 'true') return false;
    if (window.RCLAB?.cartOpenBlocked) {
      closeUpcartQuietly();
      if (typeof offer.interceptAdd === 'function') offer.interceptAdd(cart);
      return true;
    }
    if (typeof offer.interceptAdd !== 'function') return false;
    if (!offer.interceptAdd(cart)) return false;
    closeUpcartQuietly();
    return true;
  };

  const notifyUpcartAfterAdd = (cart) => {
    syncCartCount();
    installOpenPatch();

    if (interceptChargerOffer(cart)) return;

    whenUpcartReady(() => {
      installOpenPatch();
      if (window.RCLAB?.cartOpenBlocked) {
        closeUpcartQuietly();
        return;
      }

      if (typeof window.upcartRegisterAddToCart === 'function') {
        window.upcartRegisterAddToCart();
        return;
      }

      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
      }

      window.upcartOpenCart();
    });
  };

  const openUpcart = () => {
    if (window.RCLAB?.cartOpenBlocked) return;

    whenUpcartReady(() => {
      installOpenPatch();
      if (window.RCLAB?.cartOpenBlocked) return;
      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
      }
      window.upcartOpenCart();
    });
  };

  window.RCLAB = window.RCLAB || {};
  window.RCLAB.openCart = openUpcart;
  window.RCLAB.cartOpenBlocked = window.RCLAB.cartOpenBlocked || false;

  document.addEventListener(
    'click',
    (event) => {
      const offer = document.querySelector('rc-charger-offer');
      if (!offer || offer.getAttribute('data-bypass') === 'true') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (
        !target.closest(
          'product-form-component .add-to-cart-button, product-form-component button[type="submit"]'
        )
      ) {
        return;
      }

      window.RCLAB.cartOpenBlocked = true;
      installOpenPatch();
      closeUpcartQuietly();
    },
    true
  );

  const patchFetchForCartAdd = () => {
    if (window.RCLAB.__upcartFetchPatched) return;
    window.RCLAB.__upcartFetchPatched = true;

    const nativeFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);
      const request = args[0];
      const url = String(typeof request === 'string' ? request : request?.url || '');

      if (window.RCLAB?.internalCartAdd) return response;
      if (CART_ADD_PATTERN.test(url)) {
        response
          .clone()
          .json()
          .then((data) => {
            if (data && !data.status) notifyUpcartAfterAdd(data);
          })
          .catch(() => {});
      }

      return response;
    };
  };

  const onCartLinesUpdate = (event) => {
    if (event.action !== 'add') return;

    const promise = event.promise;
    if (!promise) {
      notifyUpcartAfterAdd();
      return;
    }

    promise
      .then((result) => {
        if (result?.detail?.didError) return;
        notifyUpcartAfterAdd(result?.cart || result?.detail);
      })
      .catch(() => {});
  };

  patchFetchForCartAdd();
  document.addEventListener(CART_LINES_UPDATE, onCartLinesUpdate, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(CART_OPEN_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    openUpcart();
  });

  whenUpcartReady(() => {
    installOpenPatch();

    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      window.upcartSubscribeCartUpdated((event) => {
        updateCartCount(getItemCount(event.cart));
      });
    }

    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded((event) => {
        updateCartCount(getItemCount(event.cart));
      });
    }

    if (typeof window.upcartSubscribeCartOpened === 'function') {
      window.upcartSubscribeCartOpened(() => {
        if (document.querySelector('rc-charger-offer.is-open')) {
          closeUpcartQuietly();
        }
      });
    }

    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      window.upcartSubscribeAddedToCart(() => {
        interceptChargerOffer();
      });
    }
  });
})();
